import React, { FC, ReactElement, ChangeEvent, useState } from 'react';

type SearchInput = {
  name: string;
  placeholder: string;
  setSearchValue: (state: any) => void;
  isSearchActive: boolean;
  setIsSearchActive: (state: boolean) => void;
  customStyles?: any;
}

const SearchInput: FC<SearchInput> = ({
  name,
  placeholder,
  setSearchValue,
  setIsSearchActive,
  customStyles
}: SearchInput): ReactElement => {
  const [ inputValue, setInputValue ] = useState<string>('');

  const handleClearValue = () => {
    setInputValue('');
    setSearchValue('');
    setIsSearchActive(false);
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === '') handleClearValue();
    setInputValue(event.currentTarget.value);
  };

  const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;
    if (inputValue === '') {
      handleClearValue();
    } else {
      setSearchValue(inputValue);
      setIsSearchActive(true);
    }
  };

  const handleOnClick = () => {
    if (inputValue === '') {
      handleClearValue();
      setIsSearchActive(false);
    } else {
      setSearchValue(inputValue);
      setIsSearchActive(true);
    }
  };

  return (
    <div
      className="freight-forwarder__search"
      style={customStyles ? customStyles.container : {}}
    >
      <input
        className="freight-forwarder__search-input"
        type='text'
        name={name}
        value={inputValue ?? ''}
        placeholder={placeholder}
        onChange={handleOnChange}
        onKeyUp={handleOnKeyUp}
      />
      {inputValue && <p className="freight-forwarder__search-clear" onClick={handleClearValue}>x</p>}
      <div
        className="freight-forwarder__search-button"
        onClick={handleOnClick}
      >
        <img
          className="freight-forwarder__search-button-icon"
          src="/images/pages/Resources/Blacklist/icon_search.svg"
          alt="search"
        />
      </div>
    </div>
  );
};

export default SearchInput;